import {
  GETKYCACCOUNTTYPELIST_SUCCESS,
  GETKYCACCOUNTTYPELIST_FAILED,
  RESET_GETKYCACCOUNTTYPELIST,
  LOADING_GETKYCACCOUNTTYPELIST,
  NETWORK_ERROR_GETKYCACCOUNTTYPELIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetKYCAccountTypeList = () => {
  return { type: RESET_GETKYCACCOUNTTYPELIST };
};

const getKYCAccountTypeList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETKYCACCOUNTTYPELIST });
  await partnerServices
    .post("getKYCAccountTypeList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(closedGetKYCAccountTypeListsuccess(res.data));
          break;
        default:
          dispatch(closedGetKYCAccountTypeListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETKYCACCOUNTTYPELIST,
        payload: err,
      });
    });
};
function closedGetKYCAccountTypeListsuccess(data) {
  return {
    type: GETKYCACCOUNTTYPELIST_SUCCESS,
    payload: data,
  };
}
function closedGetKYCAccountTypeListFailed(data) {
  return {
    type: GETKYCACCOUNTTYPELIST_FAILED,
    payload: data,
  };
}

export { getKYCAccountTypeList, resetGetKYCAccountTypeList };
